// Default brand: the multi-tenant app, every tenant customizes itself from the backend.
// A brand build (REACT_APP_BRAND=<brand>) replaces this file with src/brands/<brand>/brand/config.js (see craco.config.js).
const config = {
  name: '',           // brand name, used as the logo alt
  appName: null,      // web app name (tab title, PWA): wins over the tenant one
  logo: null,         // static logo: wins over the tenant one
  icon: null,         // web app icon (favicon, home screen, PWA): wins over the tenant one
  splash: null,       // splash image (assets/splash.png): the app opening loader looks like the native splash
  splashColor: null,  // splash background color, shown while the image loads
  theme: null,        // static personalizations: win over the tenant ones
  strings: {},        // translations merged over src/services/i18n/lang/it.json
  fontsUrl: null,     // stylesheet with the brand fonts
  loginIntro: false,  // login side panel (desktop) and micro onboarding (mobile)
  poweredBy: false,   // "Powered by thefaculty" footer
}

export default config
